import { Box, ChakraProvider, Grid, VStack } from '@chakra-ui/react';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { StateMachineProvider } from 'little-state-machine';
import { ErrorBoundary } from 'react-error-boundary';
import { QueryClient, QueryClientProvider } from 'react-query';

import keycloak from '../../framework/utils/KeycloakUtils';
import ClickGuard from '../components/ClickGuard';
import engeneTheme from '../constants/theme';
import { GlobalStoreInitializer } from '../GlobalStore';
// import { ColorModeSwitcher } from '../../ColorModeSwitcher';
import AppRouter from '../routes';
import { ColorProvider } from './ColorProvider';
import ErrorFallback from './error-boundary/ErrorFallback';
import { MasterProvider } from './MasterProvider';
import { SizeProvider } from './SizeProvider';

// Initializing global store.
GlobalStoreInitializer.createGlobalStore();

// React Query: create Query Client.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 300000,
    },
  },
});

const App = () => (
  <ChakraProvider theme={engeneTheme}>
    <SizeProvider>
      <ColorProvider>
        <StateMachineProvider>
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <ReactKeycloakProvider
              authClient={keycloak}
              initOptions={{ pkceMethod: 'S256' }}
              onEvent={(event, error) => {
                console.debug('onKeycloakEvent', event, error);
                // if (event === 'onAuthSuccess') UserInfoAccessor.setUserInfo();
              }}
              onTokens={(tokens) => console.debug('onKeycloakTokens', tokens)}
            >
              <MasterProvider>
                <QueryClientProvider client={queryClient}>
                  <ClickGuard />
                  <Box textAlign="center" fontSize="xl">
                    <Grid minHeight="100vh" padding={3}>
                      {/* <ColorModeSwitcher justifySelf="flex-end" /> */}
                      <VStack spacing={8} width="auto">
                        <AppRouter />
                      </VStack>
                    </Grid>
                  </Box>
                </QueryClientProvider>
              </MasterProvider>
            </ReactKeycloakProvider>
          </ErrorBoundary>
        </StateMachineProvider>
      </ColorProvider>
    </SizeProvider>
  </ChakraProvider>
);
export default App;
